module.exports = __webpack_public_path__ + "static/media/om_hairstyle_combover_front.21bbda1b.png";